<template>
    <div class="dropdown" v-if="options">
  
      <!-- Dropdown Input -->
      <input class="dropdown-input"
        :name="name"
        @focus="showOptions"
        @blur="exit()"
        @keyup="keyMonitor"
        v-model="searchFilter"
        :disabled="disabled"
        :placeholder="placeholder" />
  
      <!-- Dropdown Menu -->
      <div class="dropdown-content"
        v-show="optionsShown">
        <div
          class="dropdown-item"
          @mousedown="selectOption(option)"
          v-for="(option, index) in filteredOptions"
          :key="index"
          :class="{ 'highlighted': index === highlightedValue }"
        >
            {{ option.title }}
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, watch, onMounted } from 'vue';
  
  const {entry, entryField, name, options, placeholder, disabled, maxItem} = defineProps({
        entry: {
            type: Object,
            default: {},
        },
        entryField: {
            type: String,
            required: true,
            default: 'vorgesetzter',
            note: 'Field of entry to store the selected option'
        },
        name: {
          type: String,
          required: false,
          default: 'dropdown',
          note: 'Input name'
        },
        options: {
          type: Array,
          required: true,
          default: [],
          note: 'Options of dropdown. An array of options with id and name',
        },
        placeholder: {
          type: String,
          required: false,
          default: 'Funktion auswählen',
          note: 'Placeholder of dropdown'
        },
        disabled: {
          type: Boolean,
          required: false,
          default: false,
          note: 'Disable the dropdown'
        },
        maxItem: {
          type: Number,
          required: false,
          default: 100,
          note: 'Max items showing'
        }
    });

    const emit = defineEmits(['change']);

    const selected = ref({});
    const optionsShown = ref(false);
    const searchFilter = ref('');
    const selectedValue = ref(entry[entryField] ? entry[entryField][0] : {});
    const highlightedValue = ref(null);

    onMounted(() => {
        let selectedOption = options.find(option => {
            if(!selectedValue.value) return false;
            return option.id === selectedValue.value.id;
        }) || {};

        selected.value = selectedOption
        selectedValue.value = selectedOption;
        searchFilter.value = selectedOption.title;
    })

    const selectOption = (option) => {
        selected.value = option;
        selectedValue.value = option;
        optionsShown.value = false;
        searchFilter.value = selectedValue.value.title;

        entry[entryField] = [selectedValue.value];

        emit('change', {
          newValue: option
        });
    };

    const showOptions = (event) => {
      scrollToField(event);

      if (!disabled) {
        searchFilter.value = '';
        optionsShown.value = true;
      }
    };

    const exit = () => {
        if (!selected.value || !selected.value.id) {
            selected.value = {};
            searchFilter.value = '';
        } else {
            searchFilter.value = selected.value.title;
        }
        // emit('selected', selected.value);
        optionsShown.value = false;
    };
    
    const keyMonitor = (event) => {
      if (event.key == "Enter") {
          if(highlightedValue.value !== null) {
            selectOption(filteredOptions.value[highlightedValue.value]);
          } else {
            if(filteredOptions.value.length > 0) {
              selectOption(filteredOptions.value[0]);
            }
          }
        }

        if (event.key == "ArrowDown") {
          if (highlightedValue.value === null) {
              highlightedValue.value = 0;
          } else {
              highlightedValue.value = Math.min(highlightedValue.value + 1, filteredOptions.value.length - 1);
          }
        }

        if (event.key == "ArrowUp") {
          if (highlightedValue.value === null) {
              highlightedValue.value = 0;
          } else {
              highlightedValue.value = Math.max(highlightedValue.value - 1, 0);
          }
        }

        if(event.key != "ArrowDown" && event.key != "ArrowUp") {
          highlightedValue.value = null;
        }
    }

    const filteredOptions = computed(() => {
        const filtered = [];
        const regOption = new RegExp(searchFilter.value, 'ig');
        for (const option of options) {

        if (!searchFilter.value || searchFilter.value.length < 1 || option.title.match(regOption)){
            if (filtered.length < maxItem) filtered.push(option);
        }
        }
        return filtered;
    })

    const scrollToField = (event) => {
      event.preventDefault();
      event.stopPropagation();

      const target = event.target;

      if(target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // watch(searchFilter, () => {
    //     if (filteredOptions.length === 0) {
    //         selected.value = {};
    //     } else {
    //         selected.value = filteredOptions[0];
    //     }
    //     // emit('filter', searchFilter.value);
    // });

  </script>
  
  <style lang="scss" scoped>
    .dropdown {
      position: relative;
       @apply grid grid-cols-1;

      .dropdown-input {
        &:hover {
        }
      }
      .dropdown-content {
        position: absolute;
        background-color: #fff;
        width: 100%;
        top: 3em;
        max-height: 248px;
        border: 1px solid #e7ecf5;
        box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);
        overflow: auto;
        z-index: 1;
        .dropdown-item {
          color: black;
          padding: 8px;
          text-decoration: none;
          display: block;
          cursor: pointer;
          &:hover {
            background-color: #e7ecf5;
            @apply text-black;
          }
          &.highlighted {
            @apply bg-primary text-white;
          }
        }
      }
      .dropdown:hover .dropdowncontent {
        display: block;
      }
    }
  </style>
